import { useGraphql } from 'utils/hooks/useGraphql';

import { fetchTreeViewWorkflowsQuery } from 'api/queries/workflowIndex';
import { FolderId, splitFolderContents } from 'modules/domains/foldering';
import { JourneySubfolder } from 'modules/domains/journey';
import { GRAPHQL_TYPENAMES } from 'modules/graphql/types';
import { TreeViewQueryResponse } from 'ui/indexPages/folders/treeView';

import { ROOT_WORKFLOW_FOLDER_NAME } from '../constants';
import {
  GraphQLWorkflow,
  GraphQLWorkflowFolderContentFilter,
  GraphQLWorkflowFolderTreeViewQueryResponse,
  GraphQLWorkflowFolderTreeViewQueryVariables,
} from '../types';
import { useRootFolderId } from './useRootFolderId';

export const useTreeViewQuery = (folderId: FolderId): TreeViewQueryResponse => {
  const rootFolderId = useRootFolderId();
  const { data } = useGraphql<
    GraphQLWorkflowFolderTreeViewQueryResponse,
    GraphQLWorkflowFolderTreeViewQueryVariables
  >(fetchTreeViewWorkflowsQuery, {
    variables: {
      folderId,
      pagination: {
        limit: 1000,
        offset: 0,
      },
      content: [GraphQLWorkflowFolderContentFilter.subfolder],
    },
    fetchPolicy: 'no-cache',
  });

  const [folders = []] = splitFolderContents<JourneySubfolder, GraphQLWorkflow>(
    (data?.workflowFolder?.content as JourneySubfolder[]) || [],
    GRAPHQL_TYPENAMES.JOURNEY,
  );

  return {
    childFolders: folders,
    childItems: [],
    folderData: data?.workflowFolder || {
      id: rootFolderId,
      name: ROOT_WORKFLOW_FOLDER_NAME,
      ancestors: [],
    },
  };
};
